<app-banner *ngIf="config.banners?.length" [banners]="config.banners" [class.fade-up]="fadedBanner"></app-banner>

<app-topic-slider *ngIf="showHomeFilter" [topics]="config.homeFilter"></app-topic-slider>

<div class="challenges-container" *ngIf="showChallengeBar && ((globalChallenge$ | async) || (assignedChallenge$ | async))">
  <app-home-challenge *ngIf="globalChallenge$ | async as challenge" [challenge]="challenge"></app-home-challenge>
  <app-home-challenge *ngIf="assignedChallenge$ | async as challenge" [challenge]="challenge"></app-home-challenge>
</div>

<app-collections [class.fade-up]="fadedBanner"></app-collections>
